/** App-owned payload for shipment track point-cloud hits (not in geo-domain). */
export type ShipmentTrackVertexPayload = {
  timestampSec: number
  battery: number | null
  /** null when the track batch had no fix_type series. */
  fixTypeCode: number | null
  /** null when the track batch had no accuracy series. */
  accuracyMeters: number | null
  /** Convoy segment id — engine uses this to thin by run without joining forks. */
  segmentId?: string
}

export function shipmentTrackVertexPayload(
  payload: Record<string, unknown> | undefined,
): ShipmentTrackVertexPayload | null {
  if (!payload) return null
  const timestampSec = payload.timestampSec
  if (typeof timestampSec !== 'number' || !Number.isFinite(timestampSec)) return null
  const battery = payload.battery
  if (battery !== null && typeof battery !== 'number') return null
  const segmentId = payload.segmentId
  const fixTypeCode =
    typeof payload.fixTypeCode === 'number' && Number.isFinite(payload.fixTypeCode)
      ? payload.fixTypeCode
      : null
  const accuracyMeters =
    typeof payload.accuracyMeters === 'number' &&
    Number.isFinite(payload.accuracyMeters)
      ? payload.accuracyMeters
      : null
  return {
    timestampSec,
    battery: battery ?? null,
    fixTypeCode,
    accuracyMeters,
    ...(typeof segmentId === 'string' ? { segmentId } : {}),
  }
}
